import React,{useState,useEffect} from "react";
import {Activity, ChevronLeft, ChevronRight, CircleMinus, CirclePlus, Minus, Plus, X } from 'lucide-react';

import { DayPicker } from "react-day-picker";

const CalendarAll =({dashboardCard1Object,returnSelectedRange})=>{

    const [selected, setSelected] = useState(null);
    
    
           const [selectedDate, setSelectedDate] = useState(null);
                const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
                const [startYear, setStartYear] = useState(2020);
                const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
                const [statusYear,setStatusYear]=useState(false)
                const [statusMonth,setStatusMonth]=useState(false)
                const [statusCalendar,setStatusCalendar]=useState(true)
                const [startDate,setStartDate]=useState("")
                const [endDate,setEndDate]=useState("")
                
                function getYearAndMonth(dateString) {
                  // Split the input string by the '-' delimiter
                  const [day, month, year] = dateString.split('-');
              
                  // Return an object containing the year and month
                  return {
                      year: parseInt(year, 10),
                      month: parseInt(month, 10)
                  };
              }
              
             
    const modifiers = {
        weekend: { dayOfWeek: [0, 6] },  // Highlight weekends
        // holiday: [new Date(2024, 11, 25), new Date(2024, 0, 1)] ,
    
        //   start: selected?.from,       // Modifier for the start date
        //     end: selected?.to 
      };
      
      const modifiersStyles = {
        weekend: {   borderRadius:"50%",background:"#f1f1f1"},
        // holiday: { color: "red", backgroundColor: "yellow" },
        selected:{ backgroundColor: "rgba(149, 143, 218,0.11)", },
        start: { color: "#fff" , backgroundColor: `${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"50%"},       // Class for the start date
            end: { color: "#fff" , backgroundColor: `${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"50%"}
      };
     
  const handleDayClick = (day) => {
     // alert(`You clicked ${date.toDateString()}`);
    //  console.log(formatDateString(day))
setSelected(formatDateString(day));
returnSelectedRange({selected:day,from:formatDateString(day?.from),to:formatDateString(day?.to)});

    //  console.log({selected:day,date:formatDateString(day)})
   
  };
  function formatDateString(dateString) {
  // Parse the date string into a Date object
  const date = new Date(dateString);
  
  // Extract day, month, and year
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
  const year = date.getFullYear();
  
  // Format as "DD-MM-YYYY"
  return `${day}-${month}-${year}`;
}










  const handlePrevious = () => {
    setStartYear((prev) => Math.max(1900, prev - 10));
  };

  const handleNext = () => {
    setStartYear((prev) => Math.min(2100 - 9, prev + 10));
   
  };

  const handleSelectMonth = (month) => {
    setSelectedMonth(month);setStatusMonth(false)
    setStatusCalendar(true)
  };
  function YearGrid({ startYear, onSelectYear, selectedYear, onPrevious, onNext }) {
    const years = Array.from({ length: 10 }, (_, i) => startYear + i);
  
    return (
      <div style={{width:"320px",marginBottom: "10px" ,marginTop: "10px"}}>
        <div style={{ display: "flex",
             justifyContent: "space-between" , padding:"10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",marginBottom: "10px" ,marginTop: "10px"}}>
       
    <div  onClick={()=>{setStatusYear(false)
        setStatusMonth(false);
    setStatusCalendar(true)}} style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"50%",}} 
    ><ChevronLeft style={{marginRight:"1px"}}  color={dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} size={30}/> </div>
     
     <button style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"80px",
         border: `${startYear <= 1900
            ?"2px solid rgba(149, 143, 218,0.41)":` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`}`,borderRadius:"10px",}} 
         onClick={onPrevious} disabled={startYear <= 1900}>
            Previous
          </button>
          <div style={{padding:"5px"}}>Select Year</div>
          <button  style={{ fontSize:"14px",padding:"6px",textAlign:"center",
            cursor:"pointer",width:"80px", border: 
            `${startYear + 25 > 2100
            ?"2px solid rgba(149, 143, 218,0.41)":` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`}`
            ,borderRadius:"10px",}} onClick={onNext} disabled={startYear + 25 > 2100}>
            Next
          </button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "10px",background:"#fff",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",}}>
          {years.map((year) => (
            <button
              key={year}
              onClick={() => {onSelectYear(year);
                setStatusYear(false) ;
                setStatusMonth(true)
                setStatusCalendar(false)
              }}
              style={{
                padding: "10px",height:"120px",
                backgroundColor: year === selectedYear ? `${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}` : "rgba(144, 202, 249,0.2)",
                color: year === selectedYear ? "white" : "black",
                borderRadius: "5px",
                border: "1px solid #ddd",
                cursor: "pointer"
              }}
            >
              {year}
            </button>
          ))}
        </div>
      </div>
    );
  }
  function MonthGrid({ onSelectMonth, selectedMonth }) {
    
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
  
    return (<>  <div style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" ,display: "flex", justifyContent: "space-between", marginBottom: "10px",marginTop: "10px"  }}>
       
        <div  onClick={()=>{setStatusYear(false)
            setStatusMonth(false);
        setStatusCalendar(true)}} 
        style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"50%",}} 
        ><ChevronLeft style={{marginRight:"1px"}}  color={dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} size={30}/> </div>
        
              <div style={{padding:"5px"}}>Select Month</div>
             <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
    
            </div> 
      <div style={{width:"320px", padding:"10px",display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "10px", marginBottom: "10px"
       ,boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" }}>
        {months.map((month, index) => (
          <button
            key={month}
            onClick={() => onSelectMonth(index)}
            style={{
              padding: "20px",
              backgroundColor: index === selectedMonth ? `${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}` : "rgba(144, 202, 249,0.2)",
              color: index === selectedMonth ? "white" : "black",
              borderRadius: "5px",
              border: "1px solid #ddd",
              cursor: "pointer"
            }}
          >
            {month}
          </button>
        ))}
      </div>
      </>);
  }
   
    return(<> <div style={{
        transform: 'translateY(10px)',marginBottom:"0px",
        opacity:  1 ,
        transition: 'transform 2s ease, opacity 2s ease',
      }}>  { <div  >
          <div style={{display:"flex",justifyContent:"center"}} ><div>
          {statusMonth?<MonthGrid onSelectMonth={handleSelectMonth} selectedMonth={selectedMonth} />
     :""} </div> </div>  <div style={{display:"flex",justifyContent:"center"}} > <div>
        
    {statusYear?<YearGrid
        startYear={startYear}
        onSelectYear={setSelectedYear}
        selectedYear={selectedYear}
        onPrevious={handlePrevious}
        onNext={handleNext}
      />  :""} </div> </div>{statusCalendar?<div><div style={{display:"flex",justifyContent:"center",}} > 
    <nav  style={{width:"320px",padding:"10px",boxShadow:"0 7px 20px 0 rgba(1,1,1,0.051)",borderRadius: "15px",background:"#fff" , display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px", marginBottom: "10px" ,marginTop: "10px" }} aria-label="">
      <div style={{ fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"10px",}}  onClick={()=>{setStatusYear(true)
        setStatusMonth(false);
    setStatusCalendar(false)}}> Change Year</div>
      <div 
      style={{  fontSize:"14px",padding:"6px",textAlign:"center",cursor:"pointer",width:"100px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"10px",}}  onClick={()=>{setStatusYear(false)
        setStatusMonth(true);
    setStatusCalendar(false)}}>Change Month</div>
    
     <div  style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth-1)} } ><ChevronLeft style={{marginRight:"1px"}}  color={dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} size={30}/> </div>
     <div style={{ color: "#fff" ,cursor:"pointer",width:"30px",height:"30px", border: ` 2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color}`,borderRadius:"50%",}} onClick={()=>{handleSelectMonth(selectedMonth+1)} } > <ChevronRight style={{marginLeft:"1px"}} color={dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} size={30}/></div>
      </nav></div>
      <div style={{display:"flex",justifyContent:"center",}}>
        
        <DayPicker 
           //   fromYear={1900}  // Start year for the dropdown
           //   toYear={2100}    // End year for the dropdown
           //   captionLayout="dropdown"  // Use dropdown layout for month and year
        
             numberOfMonths={1}
               mode="range"
               selected={selectedDate}
               onSelect={(date)=>{setSelectedDate(date)
                   setStartDate((date?.from));
         
                   setEndDate((date?.to))
                   handleDayClick(date)
                   
                }}
               month={new Date(selectedYear, selectedMonth)}// Show the selected year in the calendar
               modifiers={modifiers}
               labelsFormatters={{
                 formatWeekdayName: (day) => day.toLocaleDateString("es-ES", { weekday: "short" })
               }} 
               styles={{
                   caption: { color: "#99cc99" },
                   day: { borderRadius: "50%" },
                  
                 }}
               components={{
             Caption: ({ month }) => <strong>{month.toLocaleString('default', { month: 'long' })}</strong>,
             Footer: () => <p>Select your preferred date.</p>
         
           }}
           
           onDayClick={()=>{}}
            disabled={[
                //  { before: new Date() }, // Disable past dates
                 // { dayOfWeek: [0] } // Disable weekends
               ]}
               modifiersStyles={modifiersStyles}
               // dayContentRenderer={(day) => (
               //   <div style={{ textAlign: 'center' }}>
               //     {day.getDate()}
               //     {day.getDay() === 0 && <span role="img" aria-label="holiday">🌟</span>} {}
               //   </div>
               // )}
               // showWeekNumber
          
           // footer={<p>End of Calendar</p>}
           // renderDay={(day) => (
           //   <div style={{ position: "relative" }}>
           //     <span>{day.getDate()}</span>
           //     {day.getDate() === 1 && <span style={{ color: "red" }}>Start</span>}
           //   </div>
           // )}
                /> </div> </div>:""}</div>}</div>
                
                <style>{`
                
                
                
                /* Day picker */



.rdp-day_button{margin:3px  !important;
height:35px  !important;width:35px  !important;box-shadow:none !important;
background:rgba(144, 202, 249,0.1);}
.rdp-range_start .rdp-day_button ,
.rdp-range_end .rdp-day_button {
    background:${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important;
    color:${dashboardCard1Object?.filterCalendarDateTab?.textColor?.color};border:5px solid #222222 !important;
}
.rdp-range_start ,
.rdp-range_end  {
    background:${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important;
    color: ${dashboardCard1Object?.filterCalendarDateTab?.textColor?.color};border:0px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important;
}
    .rdp-selected .rdp-day_button{background:${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important;
    border:5px solid #222222 !important; box-shadow:0 7px 20px 0 rgba(1,1,1,0.051);
}
.rdp-nav .rdp-button_previous,.rdp-nav .rdp-button_next{ margin:3px  !important;
    color: ${dashboardCard1Object?.filterCalendarDateTab?.textColor?.color};border:2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important;
    margin: 5px;margin-right:10px;border-radius: 50%; display:none !important;
}
.rdp-selected .rdp-day_button{border:2px solid ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important;
    border-radius: 50% !important;
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.051);
}.rdp-month{box-shadow:0 7px 20px 0 rgba(1,1,1,0.051);
    border-radius: 15px !important;background: #fff;padding:5px;padding-top:15px;
}.rdp-month table{
  margin:5px !important;
    
}
.rdp-disabled .rdp-day_button{border:2px solid rgb(218, 143, 143) !important;
    border-radius: 50% !important;color:rgb(218, 143, 143) !important;
    box-shadow:0 7px 20px 0 rgba(1,1,1,0.051);
}
.rdp-month_caption{
   margin-left:20px !important;
}
.rdp-chevron{fill:${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important}
.rdp-today{ color: ${dashboardCard1Object?.filterCalendarDateTab?.bgColor?.color} !important; font-size:18px !important;
font-weight:999;}`}</style>
                </>)
}
export default CalendarAll;